/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import _ from "underscore";
import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../storeUtils";
import { storageFactory } from "../../../utils/storageFactory";
import * as UtilsHelper from "../../../utils/utilsHelper";
import APP_CONST from "../../core/shared/constants";

const initialState = {
  showLoaderComponent: false,
  templateImport: {},
  configuration: {},
  templateImportFail: {},
  loggedInUser: {},
  activeAdminTab: "TMF structure",
  tmfStructureData: {},
  artifactLoading: false,
  zoneData: [],
  orgTemplates: [],
  studyTemplates: [],
  viedocTemplates: [],
  selectedTempID: "",
  isLoading: false,
  isExporting: false,
  selectedLoading: false,
  loadingTempID: "",
  instantiateLoading: false,
  viewDialog: {
    open: false,
    from: "",
    zoneData: {},
    sectionData: {},
    artifactData: {},
  },
  exportingList: [],
  deletedTempID: "",
  eTMFArchivingLoading: false,
  archiveErrStatus: "",
  eTMFArchiveTab: {},
  templateImporting: "",
  maintenanceStatus: "",
  mileStoneList: [],
  countryList: [],
  siteList: [],
  milestoneDropDownList: {},
  zoneSectionDcocModel: [],
  milestoneGroupList: [],
  zoneSectionDocModel: [],
  datingConventionList: [],
  artifactFail: "",
  isEditLoading: false,
  rawDatingConventionList: [],
  changeditems: "",
  ischangefound: false,
  revertChange: {},
  applyChange: {},
  isChangeLoading: false,
  fileScreeningStatus: {},
  importStatus: "",
  errorStatusMessage: "",
  mileStoneInfoList: {},
  viewMilestoneListLoading: false,
  isViewMilestoneList: false,
  mileStoneObjInfo: {},
  milestoneCount: 0,
  isMilestoneViewLoading: false,
  isSingleMilestoneView: false,
  artifactCount: 0,
  artifactList: [],
  showToaster: false,

  mileStoneListWithGroup: [],
  milestoneGroup: [],
  mileStoneLastModified: "",
  milestoneActionFail: "",
  isArtifactEditSuccess: false,
  isMilestoneChanged: false,
  errorFields: [],
  formErrorValues: {},
  isArchiveLoading: false,
  latestArchiveInfo: [],
  isGeneratingAuditTrail: false,
  generateAuditTrailInfo: {},
  isCancelBeforeSuccess: false,
  isCancelLoading: false,
  settings: {
    ismilestoneenabled: false,
    islockdoconapproveenabled: false,
    isreasonforunlockdocenabled: false,
    isshareddropzoneenabled: false,
    isprivatedropzoneenabled: false,
    istmflevelenabled: false,
    isaggridincluded: false,
    displaytemplate: "",
    downloadtemplate: "",
    archivetemplate: "",
    showstructurenumber: false,
    isaggridenabled: false,
  },
  isDropZoneSettingsLoaded: false,
  isDropZoneFileCountsLoaded: false,
  sharedenabled: true,
  privateenabled: false,
  sharedfilecount: 1,
  privatefilecount: 1,
  dropZoneFileScreeningStatus: {},
  isDropZoneCancelBeforeSuccess: false,
  progressDropZoneFiles: [],
  invalidDoc: [],
  dropZoneDoc: [],
  activeDropzone: "",
  downloadingFiles: [],
  lockStatus: "",
  isEtmfLocked: false,
  isLockLoading: false,
  agGridFrom: "",
  customizedColState: "undefined",
  customizedFilterState: "undefined",
  lastMode: "",
  presentMode: "",
  isSearchHappend: false,
  isCloseHappend: false,
  isTemplateCancel: false,
  datePattern: "",
  fullDateTimePattern: "",
  dateLocale: "en-us",
  isTmfStructDetailsLoading: false,
  structurename: "",
  structureversion: "",
  tmfmodelversion: "",
  isDeleting: false,
  isEditing: false,
  isDeleteLoading: false,
  token_info: {},
  tokenExpiryDate: "",
  remainingTime: 0,
  templateInitializing: false,
  isFileDownloading: false,
  deatilspagecontentseparate: " ",
  isCountLoading: false,
  isSwitching: false,
  isChangeSequenceLoading: false,
  isInitialAuditCancel: false
};

const localStore = storageFactory(() => sessionStorage);

export const templateReducer = (
  state = initialState,
  action = { type: "" }
) => {
  switch (action.type) {
    case actionTypes.ETMF_TRACKING:
      return updateObject(state, { isSwitching: true });
    case `${actionTypes.ETMF_TRACKING}_SUCCESS`:
      return updateObject(state, { isSwitching: false });
    case `${actionTypes.ETMF_TRACKING}_FAILED`:
      return updateObject(state, { isSwitching: false });
    case `${actionTypes.GET_DOCU_TEMPLATE_NAMES}_SUCCESS`:
      return updateObject(state, { documentTemplateNames: action.payload });
    case `${actionTypes.GET_COMPLETE_AUDIT_TRAIL}_INITAL`:
      return updateObject(state, { isArchiveLoading: true });
    case `${actionTypes.GET_COMPLETE_AUDIT_TRAIL}_FAILED`:
      return updateObject(state, { isArchiveLoading: false });
    case `${actionTypes.GET_COMPLETE_AUDIT_TRAIL}_SUCCESS`:
      return updateObject(state, {
        isArchiveLoading: !action.isFrom, // set this value based on "live" key passed from saga in order to avoid flicker, while transistion between loader to progress bar in audit page.
        latestArchiveInfo: action.payload,
      });
    case actionTypes.GENERATE_COMPLETE_AUDIT_TRAIL:
      return updateObject(state, {
        isGeneratingAuditTrail: true,
        showLoaderComponent: true,
        isCancelBeforeSuccess: false,
        isCancelLoading: false,
        generateAuditTrailInfo: { percentage: 0 },
      });
    case `${actionTypes.GENERATE_COMPLETE_AUDIT_TRAIL}_FAILED`:
      return updateObject(state, {
        isGeneratingAuditTrail: false,
        showLoaderComponent: false,
        generateAuditTrailInfo: {},
      });
    case `${actionTypes.GENERATE_COMPLETE_AUDIT_TRAIL}_SUCCESS`:
      const { percentage, status, latest } = action.payload;
      let updateLatestArchiveInfo = state.latestArchiveInfo;
      if (percentage === 100 && status === "Completed" && !_.isEmpty(latest)) {
        updateLatestArchiveInfo = latest;
      }
      return updateObject(state, {
        isGeneratingAuditTrail: !(
          percentage === 100 || ["Cancelled", "Failed"].includes(status)
        ),
        generateAuditTrailInfo: action.payload,
        latestArchiveInfo: updateLatestArchiveInfo,
        isCancelLoading: state.isCancelLoading
          ? !["Completed", "Cancelled", "Failed"].includes(status)
          : false,
        isArchiveLoading: false,
        showLoaderComponent: false,
      });
    case `${actionTypes.GENERATE_COMPLETE_AUDIT_TRAIL}_STATUS`:
      return updateObject(state, {});
    case `${actionTypes.GENERATE_COMPLETE_AUDIT_TRAIL}_CANCEL`:
      return updateObject(state, {
        generateAuditTrailInfo: {
          percentage: state.generateAuditTrailInfo.percentage,
        },
        isCancelLoading: true,
      });
    case actionTypes.DOWNLOAD_COMPLETE_AUDIT_TRAIL:
      let downloadingFiles = state.downloadingFiles;
      downloadingFiles.push(action.payload.id);
      return updateObject(state, {
        downloadingFiles: downloadingFiles,
        isFileDownloading: true,
      });
    case `${actionTypes.DOWNLOAD_COMPLETE_AUDIT_TRAIL}_FAILED`:
      const removeFailedFiles = state.downloadingFiles.filter(
        (id) => id !== action.id
      );
      return updateObject(state, {
        downloadingFiles: removeFailedFiles,
        isFileDownloading: false,
      });
    case `${actionTypes.DOWNLOAD_COMPLETE_AUDIT_TRAIL}_SUCCESS`:
      const removeFiles = state.downloadingFiles.filter(
        (id) => id !== action.payload
      );
      return updateObject(state, {
        downloadingFiles: removeFiles,
        isFileDownloading: false,
      });
    case `${actionTypes.GENERATE_COMPLETE_AUDIT_TRAIL}_CANCEL_BEFORE_SUCCESS`:
      return updateObject(state, {
        isCancelBeforeSuccess: true,
        isCancelLoading: true,
        isFileDownloading: false,
      });
    case actionTypes.SET_INITIAL_AUDIT_CANCEL:
        return updateObject(state, {
          isInitialAuditCancel: action.payload
        })  
    case actionTypes.GET_LOCK_STATUS:
      return updateObject(state, { isLockLoading: true });
    case `${actionTypes.GET_LOCK_STATUS}_FAILED`:
      return updateObject(state, { isLockLoading: false });
    case `${actionTypes.GET_LOCK_STATUS}_SUCCESS`:
      return updateObject(state, {
        lockStatus: action.payload.etmfstatus,
        lockedon: action.payload.lockedon,
        lockedby: action.payload.lockedby,
        isEtmfLocked: action.payload.isetmflocked,
        isLockLoading: false,
      });
    case actionTypes.SET_ETMF_LOCK:
      return updateObject(state, { isLockLoading: true });
    case `${actionTypes.SET_ETMF_LOCK}_SUCCESS`:
      return updateObject(state, {
        isEtmfLocked: true,
        isLockLoading: false,
        lockedon: action.payload.lockedon,
        lockedby: action.payload.lockedby,
      });
    case `${actionTypes.SET_ETMF_LOCK}_FAILED`:
      return updateObject(state, {
        isLockLoading: false,
      });
    case actionTypes.SET_ETMF_UNLOCK:
      return updateObject(state, { isLockLoading: true });
    case `${actionTypes.SET_ETMF_UNLOCK}_SUCCESS`:
      return updateObject(state, { isEtmfLocked: false, isLockLoading: false });
    case `${actionTypes.SET_ETMF_UNLOCK}_FAILED`:
      return updateObject(state, {
        isLockLoading: false,
      });

    case `${actionTypes.DELETE}`:
      return updateObject(state, { isDeleteLoading: true });
    case `${actionTypes.DELETE}_SUCCESS`:
      const updatedDeleteZone = action.payload.zonedata;
      const activeDeleteZoneId = action.payload.zoneId;
      const activeDeleteSectionId = action.payload.sectionId;
      const activeDeleteArtifactId = action.payload.artifactId;
      let updatedDeleteZonelist = [...state.zoneData];
      if (_.isEmpty(updatedDeleteZone)) {
        updatedDeleteZonelist = updatedDeleteZonelist.filter(
          (obj) => obj.origid !== activeDeleteZoneId
        );
      } else {
        updatedDeleteZonelist = updatedDeleteZonelist.map((obj) => {
          let returnZoneObj = obj;
          if (returnZoneObj.origid === activeDeleteZoneId) {
            returnZoneObj = {
              recentModifiedOn: action.payload.lastmodifiedon,
              ...updatedDeleteZone,
            };
          }
          return returnZoneObj;
        });

        updatedDeleteZonelist = updatedDeleteZonelist.map((obj) => {
          let returnZoneObj = obj;
          if (returnZoneObj.origid === activeDeleteZoneId) {
            let updatedDeleteSectionlist = returnZoneObj.sections.map(
              (sectionObj) => {
                let returnSectionsObj = sectionObj;

                if (returnSectionsObj.origid === activeDeleteSectionId) {
                  let updatedDeleteArtifactlist =
                    returnSectionsObj.artifacts.map((artifactObj) => {
                      let returnArtifactObj = artifactObj;
                      if (returnArtifactObj.origid === activeDeleteArtifactId) {
                        returnArtifactObj = {
                          ...returnArtifactObj,
                          recentModifiedOn: action.payload.lastmodifiedon,
                        };
                      }
                      return returnArtifactObj;
                    });

                  returnSectionsObj = {
                    ...returnSectionsObj,
                    recentModifiedOn: action.payload.lastmodifiedon,
                    artifacts: updatedDeleteArtifactlist,
                  };
                }
                returnZoneObj.sections = returnSectionsObj;
                return returnSectionsObj;
              }
            );

            returnZoneObj = {
              ...returnZoneObj,
              recentModifiedOn: action.payload.lastmodifiedon,
              sections: updatedDeleteSectionlist,
            };
          }
          return returnZoneObj;
        });
      }

      return updateObject(state, {
        isDeleteLoading: false,
        zoneData: updatedDeleteZonelist,
      });

    case `${actionTypes.DELETE}_FAILED`:
      return updateObject(state, { isDeleteLoading: false });

    case actionTypes.GET_ENABLING_MILESTONE_STATUS:
      return updateObject(state, { isStatusLoading: true, isDropZoneSettingsLoaded: false });
    case `${actionTypes.GET_ENABLING_MILESTONE_STATUS}_FAILED`:
      return updateObject(state, { isStatusLoading: false, isDropZoneSettingsLoaded: false });
    case `${actionTypes.GET_ENABLING_MILESTONE_STATUS}_SUCCESS`:
      const response = action.payload;
      return updateObject(state, {
        isStatusLoading: false,
        settings: {
          ismilestoneenabled: response.ismilestoneenabled,
          islockdoconapproveenabled: response.islockdoconapproveenabled,
          isreasonforunlockdocenabled: response.isreasonforunlockdocenabled,
          isshareddropzoneenabled: response.isshareddropzoneenabled,
          isprivatedropzoneenabled: response.isprivatedropzoneenabled,
          istmflevelenabled: response.istmflevelenabled,
          isaggridincluded: response.isaggridincluded,
          displaytemplate: response.displaytemplate,
          downloadtemplate: response.downloadtemplate,
          archivetemplate: response.archivetemplate,
          showstructurenumber: response.showstructurenumber,
        },
        isDropZoneSettingsLoaded: true,
      });
    case actionTypes.UPDATING_ENABLING_MILESTONE_STATUS:
      return updateObject(state, {
        isEditLoading: true,
        isStatusLoading: true,
      });
    case `${actionTypes.UPDATING_ENABLING_MILESTONE_STATUS}_FAILED`:
      return updateObject(state, {
        isEditLoading: false,
        isStatusLoading: false,
      });
    case `${actionTypes.UPDATING_ENABLING_MILESTONE_STATUS}_SUCCESS`:
      const updatedResponse = action.payload;
      return updateObject(state, {
        settings: {
          ismilestoneenabled: updatedResponse.ismilestoneenabled,
          islockdoconapproveenabled: updatedResponse.islockdoconapproveenabled,
          isreasonforunlockdocenabled:
            updatedResponse.isreasonforunlockdocenabled,
          isshareddropzoneenabled: updatedResponse.isshareddropzoneenabled,
          isprivatedropzoneenabled: updatedResponse.isprivatedropzoneenabled,
          istmflevelenabled: updatedResponse.istmflevelenabled,
          isaggridincluded: updatedResponse.isaggridincluded,
          displaytemplate: updatedResponse.displaytemplate,
          downloadtemplate: updatedResponse.downloadtemplate,
          archivetemplate: updatedResponse.archivetemplate,
        },
        isEditLoading: false,
        isStatusLoading: false,
        showToaster: true,
      });
    case actionTypes.CLEAR_SETTING_TOASTER_MESSAGE:
      return updateObject(state, { showToaster: false });
    case actionTypes.MAINTENANCE_ON_OFF:
      return updateObject(state, { isEditLoading: true });
    case `${actionTypes.MAINTENANCE_ON_OFF}_FAILED`:
      return updateObject(state, { isEditLoading: false });
    case `${actionTypes.MAINTENANCE_ON_OFF}_SUCCESS`:
      const updateTMFStructure = {
        ...state.tmfStructureData,
        ...action.payload,
      };
      return updateObject(state, {
        tmfStructureData: updateTMFStructure,
        isEditLoading: false,
      });
    case `${actionTypes.MAINTENANCE_STATUS}_FAILED`:
      return updateObject(state, {});
    case `${actionTypes.MAINTENANCE_STATUS}_SUCCESS`:
      return updateObject(state, {
        maintenanceStatus: action.payload,
      });

    case `${actionTypes.EDIT_ZONE}`:
      return updateObject(state, { editError: "", isEditLoading: true });
    case `${actionTypes.EDIT_ZONE}_SUCCESS`:
      const editZoneObj = action.payload;
      const updateZoneList = state.zoneData.map((obj) => {
        let returnZoneObj = obj;
        returnZoneObj["recentModifiedOn"] = editZoneObj.lastmodifiedon;
        if (obj.origid === editZoneObj.zoneid) {
          returnZoneObj = {
            ...obj,
            ...editZoneObj,
            name: editZoneObj.zonename,
            origid: editZoneObj.zoneid,
          };
        }
        return returnZoneObj;
      });
      return updateObject(state, {
        editError: "",
        isEditLoading: false,
        zoneData: [...updateZoneList],
      });
    case `${actionTypes.EDIT_ZONE}_FAILED`:
      return updateObject(state, {
        editError: action.payload,
        isEditLoading: false,
      });

    case `${actionTypes.EDIT_ZONE}_CLEAR_ERROR`:
      return updateObject(state, {
        editError: "",
      })
    case `${actionTypes.EDIT_SECTION}`:
      return updateObject(state, { editError: "", isEditLoading: true });
    case `${actionTypes.EDIT_SECTION}_SUCCESS`:
      const editSectionObj = action.payload;
      const activeZoneid = editSectionObj.sectionid.split(".")[0];
      const updateSectionList = state.zoneData.map((zoneObj) => {
        let returnObj = zoneObj;
        if (zoneObj.origid === activeZoneid) {
          returnObj["recentModifiedOn"] = editSectionObj.lastmodifiedon;
          const updatedSection = zoneObj.sections.map((sectionObj) => {
            let returnSecObj = sectionObj;
            if (sectionObj.origid === editSectionObj.sectionid) {
              returnSecObj = {
                ...returnSecObj,
                ...editSectionObj,
                name: editSectionObj.sectionname,
                origid: editSectionObj.sectionid,
              };
            }
            return returnSecObj;
          });
          returnObj.sections = updatedSection;
        }
        return returnObj;
      });

      return updateObject(state, {
        editError: "",
        isEditLoading: false,
        zoneData: [...updateSectionList],
      });
    case `${actionTypes.EDIT_SECTION}_FAILED`:
      return updateObject(state, {
        editError: action.payload,
        isEditLoading: false,
      });

    case actionTypes.CLEAR_CHANGES_FOUND:
      return updateObject(state, { ischangefound: false });

    case actionTypes.GET_MILESTONE_LIST:
      return updateObject(state, {});
    case `${actionTypes.GET_MILESTONE_LIST}_FAILED`:
      return updateObject(state, {});
    case `${actionTypes.GET_MILESTONE_LIST}_SUCCESS`:
      const { milestoneresult } = action.payload || [];
      const updatedMilestoneList = milestoneresult.map((obj) => ({
        ...obj,
        text: obj.name,
      }));
      return updateObject(state, {
        mileStoneList: updatedMilestoneList,
      });

    case actionTypes.GET_MILESTONE_VIEW_HANDLER:
      return updateObject(state, { artifactLoading: true });
    case `${actionTypes.GET_MILESTONE_VIEW_HANDLER}_SUCCESS`:
      return updateObject(state, {
        mileStoneViewHandler: action.payload,
        artifactLoading: false,
      });
    case `${actionTypes.GET_MILESTONE_VIEW_HANDLER}_FAILED`:
      return updateObject(state, { artifactLoading: false });

    case actionTypes.GET_TMF_STRUCTURE_CHANGES:
      return updateObject(state, { isChangeLoading: true });
    case `${actionTypes.GET_TMF_STRUCTURE_CHANGES}_FAILED`:
      return updateObject(state, { isChangeLoading: false });
    case `${actionTypes.GET_TMF_STRUCTURE_CHANGES}_SUCCESS`:
      const { changeditems, ischangefound, tmfcounts } = action.payload;
      const checkMilestoneChanged = _.find(changeditems, {
        category: "MILESTONE",
      });
      let updatedTMFStructure = state.tmfStructureData;
      if (tmfcounts) {
        updatedTMFStructure = {
          ...updatedTMFStructure,
          ...tmfcounts,
        };
      }
      return updateObject(state, {
        changeditems: changeditems || [],
        isMilestoneChanged: !_.isEmpty(checkMilestoneChanged),
        ischangefound,
        isChangeLoading: false,
        tmfStructureData: updatedTMFStructure,
      });
    case `${actionTypes.REVERT_STRUCTURE_CHANGES}`:
      return updateObject(state, { isEditLoading: true });
    case `${actionTypes.REVERT_STRUCTURE_CHANGES}_SUCCESS`:
      return updateObject(state, {
        isEditLoading: false,
        revertChange: action.payload,
      });
    case `${actionTypes.REVERT_STRUCTURE_CHANGES}_FAILED`:
      return updateObject(state, { isEditLoading: false });
    case `${actionTypes.APPLY_STRUCTURE_CHANGES}`:
      return updateObject(state, { isEditLoading: true });
    case `${actionTypes.APPLY_STRUCTURE_CHANGES}_SUCCESS`:
      return updateObject(state, {
        isEditLoading: false,
        applyChange: action.payload,
      });
    case `${actionTypes.APPLY_STRUCTURE_CHANGES}_FAILED`:
      return updateObject(state, { isEditLoading: false });

    case actionTypes.GET_VIEW_ZONE_SEC_ARTIF:
      const updatedViewData = state.viewDialog;
      updatedViewData.from = action.payload && action.payload.from;
      updatedViewData.mode = action.payload && action.payload.mode;
      updatedViewData.open = true;
      return updateObject(state, {
        viewLoading: true,
        viewDialog: updatedViewData,
      });
    case `${actionTypes.GET_VIEW_ZONE_SEC_ARTIF}_CLOSE`: {
      const closedViewData = state.viewDialog;
      closedViewData.open = false;
      return updateObject(state, {
        viewLoading: false,
        viewDialog: closedViewData,
      });
    }
    case `${actionTypes.GET_VIEW_ZONE_SEC_ARTIF}_SUCCESS`: {
      const { from } = action.payload;
      const updatedViewDialog = state.viewDialog;
      switch (from) {
        case "zone":
          updatedViewDialog.zoneData = action.payload;
          break;
        case "section":
          updatedViewDialog.sectionData = action.payload;
          break;
        case "artifact":
          updatedViewDialog.artifactData = action.payload;
          break;
        default:
          break;
      }
      return updateObject(state, {
        viewLoading: false,
        viewDialog: updatedViewDialog,
      });
    }
    case `${actionTypes.GET_VIEW_ZONE_SEC_ARTIF}_FAILED`:
      return updateObject(state, { viewLoading: false });
    case actionTypes.ADD_NEW_ARTIFACT:
      return updateObject(state, {
        isEditLoading: true,
        isArtifactEditSuccess: false,
        artifactFail: "",
      });
    case `${actionTypes.ADD_NEW_ARTIFACT}_FAILED`:
      const errorText = action.payload;
      return updateObject(state, {
        artifactFail: errorText,
        isEditLoading: false,
        isArtifactEditSuccess: false,
      });

    case `${actionTypes.ADD_NEW_ARTIFACT}_CLEAR_ERROR`:
      return updateObject(state, {
        artifactFail: "",
      })
    case `${actionTypes.ADD_NEW_ARTIFACT}_SUCCESS`:
      const { zoneList, zoneId, sectionId, artifactId } = action.payload;
      let updatedZone = zoneList;
      updatedZone["recentModifiedOn"] = action.payload.lastmodifiedon;
      updatedZone["sections"] = zoneList["sections"].map((secObj) => {
        let returnSecObj = secObj;
        if (returnSecObj.origid === sectionId) {
          returnSecObj["recentModifiedOn"] = action.payload.lastmodifiedon;
        }
        return returnSecObj;
      });
      let addedZoneList = [...state.zoneData];
      const findZone = _.find(addedZoneList, { origid: zoneId });
      if (!_.isEmpty(findZone)) {
        addedZoneList = addedZoneList.map((obj) => {
          let returnZoneObj = obj;
          if (obj.origid === zoneId) {
            returnZoneObj = {
              ...updatedZone,
            };
          } else {
          }
          return returnZoneObj;
        });
      } else {
        addedZoneList.push(updatedZone);
      }
      return updateObject(state, {
        zoneData: [...addedZoneList],
        isEditLoading: false,
        isArtifactEditSuccess: true,
        artifactFail: "",
      });
    case actionTypes.GET_DATING_CONVENTION_LIST:
      return updateObject(state, {});
    case `${actionTypes.GET_DATING_CONVENTION_LIST}_FAILED`:
      return updateObject(state, {});
    case `${actionTypes.GET_DATING_CONVENTION_LIST}_SUCCESS`:
      let updateDatingConventionList = action.payload.datingconvention || [];
      updateDatingConventionList = updateDatingConventionList.map((list) => ({
        id: list,
        name: list,
      }));
      updateDatingConventionList.push({ id: "", name: APP_CONST.TEXT_NEW });
      return updateObject(state, {
        datingConventionList: updateDatingConventionList,
        rawDatingConventionList: action.payload.datingconvention || [],
      });

    case actionTypes.TMF_STRUCTURE_DATA: {
      const loadingObj =
        action.payload === "onload"
          ? { isLoading: true }
          : { instantiateLoading: true };
      return updateObject(state, { ...loadingObj });
    }
    case `${actionTypes.TMF_STRUCTURE_DATA}_FAILED`:
      return updateObject(state, {
        isLoading: false,
        instantiateLoading: false,
      });
    case `${actionTypes.TMF_STRUCTURE_DATA}_SUCCESS`:
      const { result } = action.payload;
      let updatedZoneList = result.zonedata || [];
      return updateObject(state, {
        tmfStructureData: result,
        zoneData: updatedZoneList,
        isLoading: false,
        instantiateLoading: false,
      });

    case actionTypes.GET_MILESTONE_COUNT:
      return updateObject(state, { isCountLoading: true });
    case `${actionTypes.GET_MILESTONE_COUNT}_FAILED`:
      return updateObject(state, { isCountLoading: false });
    case `${actionTypes.GET_MILESTONE_COUNT}_SUCCESS`:
      const { milestoneCount } = action.payload || {};
      return updateObject(state, {
        milestoneCount: milestoneCount,
        isEditLoading: false,
        isCountLoading: false
      });

    case actionTypes.ADD_NEW_MILESTONE:
      return updateObject(state, {
        isEditLoading: true,
      });
    case `${actionTypes.ADD_NEW_MILESTONE}_FAILED`:
      let { message, existingfields, formErrorValues } = action.payload;
      return updateObject(state, {
        milestoneActionFail: message || "",
        isEditLoading: false,
        errorFields: existingfields,
        // formErrorValues: { ...formErrorValues },
      });
    case `${actionTypes.ADD_NEW_MILESTONE}_SUCCESS`:
      return updateObject(state, {
        mileStoneLastModified: action.payload.lastmodifiedon,
        isEditLoading: false,
        isSingleMilestoneView: false,
        milestoneActionFail: "",
        errorFields: [],
      });

    case `${actionTypes.ADD_NEW_MILESTONE}_HIDE_ERROR`:
      return updateObject(state, {
        milestoneActionFail: "",
        errorFields: [],
        milestoneSequenceChangeFail: "",
      })

    case actionTypes.EDIT_MILESTONE:
      return updateObject(state, {
        isEditLoading: true,
      });
    case `${actionTypes.EDIT_MILESTONE}_FAILED`:
      return updateObject(state, {
        milestoneActionFail: action.payload.message || "",
        isEditLoading: false,
        errorFields: action.payload.existingfields,
        // formErrorValues: { ...formErrorValues },
      });
    case `${actionTypes.EDIT_MILESTONE}_SUCCESS`:
      // let mileStoneInfoList = _.groupBy(action.payload.milestones, "group") || [];
      return updateObject(state, {
        mileStoneLastModified: action.payload.lastmodifiedon,
        isEditLoading: false,
        isSingleMilestoneView: false,
        mileStoneObjInfo: {},
        milestoneActionFail: "",
      });
    case actionTypes.CHANGE_MILESTONE_SEQUENCE:
      return updateObject(state, { isChangeSequenceLoading: true });
    case `${actionTypes.CHANGE_MILESTONE_SEQUENCE}_FAILED`:
      return updateObject(state, {
        milestoneSequenceChangeFail: action.payload || "",
        isChangeSequenceLoading: false,
      });
    case `${actionTypes.CHANGE_MILESTONE_SEQUENCE}_SUCCESS`:
      return updateObject(state, {
        mileStoneLastModified: action.payload.lastmodifiedon,
        isChangeSequenceLoading: false,
      });

    case actionTypes.DELETE_MILESTONE:
      return updateObject(state, { isEditLoading: true });
    case `${actionTypes.DELETE_MILESTONE}_FAILED`:
      return updateObject(state, {
        milestoneActionFail: action.payload || "",
        isEditLoading: false,
      });
    case `${actionTypes.DELETE_MILESTONE}_SUCCESS`:
      return updateObject(state, {
        mileStoneLastModified: action.payload.lastmodifiedon,
        mileStoneObjInfo: {},
        isEditLoading: false,
        isSingleMilestoneView: false,
      });

    case actionTypes.GET_MILESTONE_INFO_LIST:
      return updateObject(state, {
        viewMilestoneListLoading: true,
        isViewMilestoneList: true,
      });
    case `${actionTypes.GET_MILESTONE_INFO_LIST}_FAILED`:
      return updateObject(state, { viewMilestoneListLoading: false });
    case `${actionTypes.GET_MILESTONE_INFO_LIST}_SUCCESS`:
      let updatedMileStoneInfoList = action.payload || [];
      updatedMileStoneInfoList = _.groupBy(updatedMileStoneInfoList, "group");
      return updateObject(state, {
        mileStoneInfoList: updatedMileStoneInfoList,
        viewMilestoneListLoading: false,
      });

    case actionTypes.CLONE_DOC_NEW_VERSION:
      return updateObject(state, {
        isNewDocVersionCreated: true,
        cloneLoading: true,
      });
    case `${actionTypes.CLONE_DOC_NEW_VERSION}_FAILED`:
      return updateObject(state, {
        isNewDocVersionCreated: false,
        cloneLoading: false,
      });
    case `${actionTypes.CLONE_DOC_NEW_VERSION}_SUCCESS`:
      return updateObject(state, {
        isNewDocVersionCreated: true,
        cloneLoading: false,
      });

    case actionTypes.GET_COUNTRY_LIST:
      return updateObject(state, {});
    case `${actionTypes.GET_COUNTRY_LIST}_FAILED`:
      return updateObject(state, {});
    case `${actionTypes.GET_COUNTRY_LIST}_SUCCESS`:
      const updatedCountrydata = action.payload.map((obj) => ({
        ...obj,
        text: obj.name,
      }));
      return updateObject(state, {
        countryList: updatedCountrydata,
      });

    case actionTypes.GET_SITE_LIST:
      return updateObject(state, {});
    case `${actionTypes.GET_SITE_LIST}_FAILED`:
      return updateObject(state, {});
    case `${actionTypes.GET_SITE_LIST}_SUCCESS`:
      const updatedSitedata = action.payload.map((obj) => ({
        ...obj,
        text: obj.name,
      }));

      return updateObject(state, {
        siteList: updatedSitedata,
      });

    case actionTypes.GET_MILESTONE_DROPDOWN_DATA:
      return updateObject(state, {});
    case `${actionTypes.GET_MILESTONE_DROPDOWN_DATA}_FAILED`:
      return updateObject(state, {});
    case `${actionTypes.GET_MILESTONE_DROPDOWN_DATA}_SUCCESS`:
      let updateMilestoneFilterList =
        action.payload.result.milestoneresult || [];
      updateMilestoneFilterList = updateMilestoneFilterList.map((obj) => ({
        ...obj,
        label: obj.name,
        value: obj.id,
      }));
      let milestoneGroupObj = _.groupBy(updateMilestoneFilterList, "group");
      let UpdatedMileStoneListWithGroup = [];
      state.milestoneGroupList?.result?.map((group) => {
        const returnObj = {
          value: `${group}_milestoneGroup_`,
          label: group,
        };
        UpdatedMileStoneListWithGroup.push(returnObj);
        UpdatedMileStoneListWithGroup = [
          ...UpdatedMileStoneListWithGroup,
          ...(milestoneGroupObj[group] || []),
        ];
      });
      return updateObject(state, {
        milestoneDropDownList: action.payload,
        mileStoneListWithGroup: UpdatedMileStoneListWithGroup,
      });

    case actionTypes.GET_MILESTONE_GROUP:
      return updateObject(state, {});
    case `${actionTypes.GET_MILESTONE_GROUP}_FAILED`:
      return updateObject(state, {});
    case `${actionTypes.GET_MILESTONE_GROUP}_SUCCESS`:
      return updateObject(state, {
        milestoneGroupList: action.payload,
      });

    case actionTypes.GET_ZONE_SECTION:
      return updateObject(state, { isLoading: true });
    case `${actionTypes.GET_ZONE_SECTION}_FAILED`:
      return updateObject(state, { isLoading: false });
    case `${actionTypes.GET_ZONE_SECTION}_SUCCESS`:
      return updateObject(state, {
        zoneSectionDocModel: action.payload,
        isLoading: false,
      });

    case actionTypes.GET_TMF_STRUCTURE:
      return updateObject(state, { isTmfStructDetailsLoading: true });
    case `${actionTypes.GET_TMF_STRUCTURE}_FAILED`:
      return updateObject(state, { isTmfStructDetailsLoading: false });
    case `${actionTypes.GET_TMF_STRUCTURE}_SUCCESS`:
      return updateObject(state, {
        structurename: action.payload.structurename,
        structureversion: action.payload.structurenamewithversion,
        tmfmodelversion: action.payload.tmfmodelversion,
        isTmfStructDetailsLoading: false,
      });

    case actionTypes.CLEAR_STRUCTURE_EDIT_CHANGES:
      return updateObject(state, { structureversion: "" });

    case actionTypes.SAVE_TMF_STRUCTURE:
      return updateObject(state, { isTmfStructDetailsLoading: true });
    case `${actionTypes.SAVE_TMF_STRUCTURE}_FAILED`:
      return updateObject(state, { isTmfStructDetailsLoading: false });
    case `${actionTypes.SAVE_TMF_STRUCTURE}_SUCCESS`:
      return updateObject(state, {
        structurename: action.payload.structurename,
        tmfmodelversion: action.payload.tmfversion,
        isTmfStructDetailsLoading: false,
      });

    case `${actionTypes.GET_SHARED_DOCUMENT}_SUCCESS`:
      return updateObject(state, {
        sharedDocumentLinks: action.payload,
      });

    case `${actionTypes.GET_SHARED_DOCUMENT}_FAILED`:
      return updateObject(state, {
        sharedDocumentLinks: [],
      });

    case `${actionTypes.GET_TIME_FORMAT}_SUCCESS`:
      let datePattern = !_.isEmpty(action.payload.datePattern)
        ? action.payload.datePattern
        : "";
      let fullDateTimePattern = !_.isEmpty(action.payload.fullDateTimePattern)
        ? action.payload.fullDateTimePattern
        : "";
      let deatilspagecontentseparate = !_.isEmpty(
        action.payload.deatilspagecontentseparate
      )
        ? action.payload.deatilspagecontentseparate
        : "  ";
      return updateObject(state, {
        datePattern: datePattern,
        fullDateTimePattern: fullDateTimePattern,
        dateLocale: action.payload.regionformat,
        deatilspagecontentseparate: deatilspagecontentseparate,
      });

    case `${actionTypes.STUDY_INFO}_FAILED`:
      return updateObject(state, { loggedInUser: {} });
    case `${actionTypes.STUDY_INFO}_SUCCESS`:
      return updateObject(state, { loggedInUser: action.payload });

    case `${actionTypes.GET_DROP_ZONE_DATA}`:
      return updateObject(state, { isLoading: true, invalidDoc: [] });
    case `${actionTypes.GET_DROP_ZONE_DATA}_SUCCESS`:
      let dropZoneDocments = [];

      if (!_.isEmpty(state.progressDropZoneFiles)) {
        dropZoneDocments = [...state.progressDropZoneFiles, ...action.payload];
      } else {
        dropZoneDocments = [...action.payload];
      }
      return updateObject(state, {
        dropZoneDoc: dropZoneDocments,
        isLoading: false,
      });
    case `${actionTypes.GET_DROP_ZONE_DATA}_FAILED`:
      return updateObject(state, { isLoading: false });

    case actionTypes.DELETE_DROPZONE:
      return updateObject(state, { loading: true });
    case actionTypes.GET_DROP_ZONE_SETTING:
      return updateObject(state, { loading: true });
    case `${actionTypes.GET_DROP_ZONE_SETTING}_FAILED`:
      return updateObject(state, { loading: false, isDropZoneFileCountsLoaded: true });
    case `${actionTypes.GET_DROP_ZONE_SETTING}_SUCCESS`:
      const dropZoneSettings = action.payload;
      return updateObject(state, {
        sharedfilecount: dropZoneSettings.sharedfilecount,
        privatefilecount: dropZoneSettings.privatefilecount,
        loading: false,
        isDropZoneFileCountsLoaded: true
      });

    case actionTypes.SET_DROP_ITEMS:
      return updateObject(state, { dropZoneDoc: [...action.payload] });

    case actionTypes.DO_DROP_ZONE_FILESCREENING_STATUS:
      let progressFileData = [
        action.payload.documentData,
        ...state.progressDropZoneFiles,
      ];
      progressFileData = progressFileData.sort(function (a, b) {
        if (a.filename < b.filename) {
          return -1;
        }
        if (a.filename > b.filename) {
          return 1;
        }
        return 0;
      });
      let getLocalstore = JSON.parse(
        localStore.getItem(action.payload.documentData.category)
      );
      getLocalstore[action.payload.docIndex] = action.payload.documentData;
      localStore.setItem(
        action.payload.documentData.category,
        JSON.stringify(getLocalstore)
      );
      // if (action.payload.documentData.category === state.activeDropzone) {
      let fileData = [...state.dropZoneDoc];
      fileData[action.payload.docIndex] = action.payload.documentData;
      fileData = fileData.filter((data) => !_.isEmpty(data));
      return updateObject(state, {
        dropZoneDoc: fileData,
        progressDropZoneFiles: progressFileData,
      });
    // } else {
    //   return updateObject(state, { progressDropZoneFiles: progressFileData });
    // }

    case actionTypes.GET_DROP_ZONE_FILESCREENING_STATUS:
      return updateObject(state, {});
    case `${actionTypes.GET_DROP_ZONE_FILESCREENING_STATUS}_FAILED`:
      return updateObject(state, {
        dropZoneFileScreeningStatus: action.payload,
      });
    case `${actionTypes.GET_DROP_ZONE_FILESCREENING_STATUS}_SUCCESS`:
      const screeningStatus = action.payload && action.payload.status;
      return updateObject(state, {
        dropZoneFileScreeningStatus: action.payload,
        // selectedLoading: state.isCancelBeforeSuccess,
      });
    case `${actionTypes.GET_DROP_ZONE_FILESCREENING_STATUS}_CANCEL`:
      return updateObject(state, {
        // selectedLoading: true
      });
    case `${actionTypes.GET_DROP_ZONE_FILESCREENING_STATUS}_CANCEL_BEFORE_SUCCESS`:
      return updateObject(state, {
        // selectedLoading: true,
        isDropZoneCancelBeforeSuccess: action.payload,
      });

    case actionTypes.SET_INVALID_FILE_ERROR:
      let invalidData = [...state.invalidDoc, action.payload.documentData];
      return updateObject(state, { invalidDoc: invalidData });
    case actionTypes.REMOVE_INVALID_DOC:
      let resetInvalidData = state.invalidDoc;
      resetInvalidData = resetInvalidData.filter(
        (data, index) => index !== action.payload.index
      );
      return updateObject(state, { invalidDoc: resetInvalidData });

    case `${actionTypes.DO_SAVE_TMF_DROP_ZONE}_SUCCESS`:
      let resetDropZoneDocument = [...state.dropZoneDoc];
      let progressFiles = [...state.progressDropZoneFiles];
      progressFiles = progressFiles.filter(
        (data) => data.guid !== action.payload.fileguid
      );
      let findIndex = resetDropZoneDocument.findIndex(
        (data) => data.guid === action.payload.fileguid
      );
      resetDropZoneDocument[findIndex] = action.payload;
      return updateObject(state, {
        dropZoneDoc: resetDropZoneDocument,
        progressDropZoneFiles: progressFiles,
      });

    case actionTypes.REMOVE_DELETE_DOC:
      let removeDoc = [...state.dropZoneDoc];
      let findDeletedDocIndex = removeDoc.filter(
        (data) => data.tmfdropzoneid !== action.payload.id
      );
      return updateObject(state, { dropZoneDoc: findDeletedDocIndex });

    case actionTypes.TEMPLATE_FILE_SCREENING_STATUS:
      return updateObject(state, {});
    case `${actionTypes.TEMPLATE_FILE_SCREENING_STATUS}_FAILED`:
      return updateObject(state, {
        fileScreeningStatus: action.payload,
        importStatus: action.payload?.responseData?.result?.status,
        errorStatusMessage: action.payload?.responseData?.result,
      });
    case `${actionTypes.TEMPLATE_FILE_SCREENING_STATUS}_SUCCESS`:
      return updateObject(state, {
        fileScreeningStatus: action.payload,
        importStatus: action.payload?.responseData?.result?.status,
        errorStatusMessage: action.payload?.responseData?.result,
      });
    case `${actionTypes.TEMPLATE_FILE_SCREENING_STATUS}_CANCEL`:
      return updateObject(state, {
        // selectedLoading: true
      });
    case `${actionTypes.IS_CANCEL_TEMPLATE}`:
      return updateObject(state, {
        isTemplateCancel: action.payload,
      });
    case `${actionTypes.TEMPLATE_FILE_SCREENING_STATUS}_CANCEL_BEFORE_SUCCESS`:
      return updateObject(state, {
        // selectedLoading: true,
        isCancelBeforeSuccess: action.payload,
      });

    case actionTypes.FETCH_ALL_TEMPLATES:
      return updateObject(state, {
        isLoading: true,
      });
    case `${actionTypes.FETCH_ALL_TEMPLATES}_FAILED`:
      return updateObject(state, { isLoading: false });
    case `${actionTypes.FETCH_ALL_TEMPLATES}_SUCCESS`: {
      const allTemplates = action.payload;
      const groupedTemplates = _.groupBy(allTemplates, "templatecategory");
      const orgTemplates = groupedTemplates["Organization template"] || [];
      const studyTemplates = groupedTemplates["Study template"] || [];
      const viedocTemplates = groupedTemplates["Viedoc System Template"] || [];

      const originalTemplateId = state.tmfStructureData.originaltemplateid;
      const findSelected = allTemplates.find(
        (obj) => obj.templateid === originalTemplateId
      );
      return {
        ...state,
        orgTemplates,
        studyTemplates,
        viedocTemplates,
        selectedTempID: (findSelected && findSelected.templateid) || "",
        isLoading: false,
      };
    }

    case `${actionTypes.EXPORT_TEMPLATE}`: {
      const exportTemplate = action.payload;
      let updateExportingList = [...state.exportingList];
      updateExportingList.push(exportTemplate.templateid);
      return updateObject(state, {
        exportingList: updateExportingList,
        isExporting: true,
      });
    }
    case `${actionTypes.EXPORT_TEMPLATE}_FAILED`: {
      const failedExportingList = _.filter(
        [...state.exportingList],
        (obj) => obj !== action.payload
      );
      return updateObject(state, {
        exportingList: failedExportingList,
        isExporting: false,
      });
    }
    case `${actionTypes.EXPORT_TEMPLATE}_SUCCESS`: {
      const successExportingList = _.filter(
        [...state.exportingList],
        (obj) => obj !== action.payload
      );
      return updateObject(state, {
        exportingList: successExportingList,
        isExporting: false,
      });
    }
    case actionTypes.DELETE_TEMPLATE: {
      return updateObject(state, { isDeleting: true });
    }
    case `${actionTypes.DELETE_TEMPLATE}_SUCCESS`: {
      const deletedTemplateData = action.payload;

      let updatedOrgTemplates = [...state.orgTemplates];
      let updatedStudyTemplates = [...state.studyTemplates];
      let updatedViedocTemplates = [...state.viedocTemplates];

      let findIndex;
      switch (deletedTemplateData.templatecategory) {
        case "Organization template": {
          findIndex = _.findIndex(updatedOrgTemplates, {
            templateid: deletedTemplateData.templateid,
          });
          if (findIndex !== -1) {
            updatedOrgTemplates.splice(findIndex, 1);
          }
          return updateObject(state, {
            orgTemplates: updatedOrgTemplates,
            isDeleting: false,
          });
        }
        case "Study template": {
          findIndex = _.findIndex(updatedStudyTemplates, {
            templateid: deletedTemplateData.templateid,
          });
          if (findIndex !== -1) {
            updatedStudyTemplates.splice(findIndex, 1);
          }
          return updateObject(state, {
            studyTemplates: updatedStudyTemplates,
            isDeleting: false,
          });
        }
        case "Viedoc System Template": {
          findIndex = _.findIndex(updatedViedocTemplates, {
            templateid: deletedTemplateData.templateid,
          });
          if (findIndex !== -1) {
            updatedViedocTemplates.splice(findIndex, 1);
          }
          return updateObject(state, {
            viedocTemplates: updatedViedocTemplates,
            isDeleting: false,
          });
        }
        default:
          return state;
      }
    }

    case `${actionTypes.DELETE_TEMPLATE}_FAILED`: {
      return updateObject(state, { isDeleting: false });
    }

    case actionTypes.SELECT_TEMPLATE:
      return updateObject(state, {
        selectedLoading: true,
        loadingTempID: action.payload.templateId,
      });
    case `${actionTypes.SELECT_TEMPLATE}_FAILED`:
      return updateObject(state, { selectedLoading: false, loadingTempID: "" });
    case `${actionTypes.SELECT_TEMPLATE}_SUCCESS`: {
      const selectedTemplate = action.payload && action.payload.result;
      return updateObject(state, {
        selectedLoading: false,
        loadingTempID: "",
        selectedTempID: selectedTemplate.templateid,
      });
    }

    case `${actionTypes.GET_REFRESH_TOKEN}_SUCCESS`: {
      const token_info = {
        tokenInfo: action.payload.token,
        tokenexpirydate: action.payload.tokenexpirydate,
        usertype: "user",
      };
      const JSONtoken_info = JSON.stringify(token_info);
      localStore.setItem("jwtToken", action.payload.token);
      localStore.setItem("token_info", JSONtoken_info);

      return updateObject(state, {
        token_info: token_info,
      });
    }

    case actionTypes.INSTANTIATE_TEMPLATE:
      return updateObject(state, {
        instantiateLoading: true,
        templateInitializing: true,
      });
    case `${actionTypes.INSTANTIATE_TEMPLATE}_SUCCESS`:
      return updateObject(state, {
        instantiateLoading: false,
        templateInitializing: false,
      });
    case `${actionTypes.INSTANTIATE_TEMPLATE}_FAILED`:
      return updateObject(state, {
        instantiateLoading: false,
        templateInitializing: false,
      });

    case actionTypes.RENAME_TEMPLATE: {
      return updateObject(state, { isEditing: true });
    }

    case `${actionTypes.RENAME_TEMPLATE}_SUCCESS`: {
      const { payload } = action;
      let orgTemplatesImport = [...state.orgTemplates];
      let studyTemplatesImport = [...state.studyTemplates];
      switch (payload.templatecategory) {
        case "Organization template": {
          const findOrgIndex = !_.isEmpty(orgTemplatesImport)
            ? _.findIndex(orgTemplatesImport, {
              templateid: payload.templateid,
            })
            : 0;
          orgTemplatesImport[findOrgIndex] = payload;
          break;
        }
        case "Study template": {
          const findIndex = !_.isEmpty(studyTemplatesImport)
            ? _.findIndex(studyTemplatesImport, {
              templateid: payload.templateid,
            })
            : 0;
          studyTemplatesImport[findIndex] = payload;
          break;
        }
        default:
          break;
      }
      return updateObject(state, {
        orgTemplates: orgTemplatesImport,
        studyTemplates: studyTemplatesImport,
        isEditing: false,
      });
    }

    case `${actionTypes.RENAME_TEMPLATE}_FAILED`: {
      return updateObject(state, { isEditing: false });
    }

    case actionTypes.TEMPLATE_IMPORT:
      return updateObject(state, { templateImporting: action.from });
    case actionTypes.TEMPLATE_IMPORT_SUCCESS: {
      let orgTemplatesImport = [...state.orgTemplates];
      let studyTemplatesImport = [...state.studyTemplates];
      let viedocTemplatesImport = [...state.viedocTemplates];
      const templateCategory =
        action.payload.category || action.payload.templatecategory;
      switch (templateCategory) {
        case "Organization template":
          orgTemplatesImport.unshift(action.payload);
          break;
        case "Study template":
          studyTemplatesImport.unshift(action.payload);
          break;
        default:
          viedocTemplatesImport.unshift(action.payload);
          break;
      }
      return {
        ...state,
        templateImporting: "",
        templateImport: action.payload,
        templateImportFail: {},
        orgTemplates: orgTemplatesImport,
        studyTemplates: studyTemplatesImport,
        viedocTemplates: viedocTemplatesImport,
      };
    }
    case actionTypes.TEMPLATE_IMPORT_FAILED:
      return updateObject(state, {
        templateImporting: "",
        templateImportFail: action.payload,
      });

    case actionTypes.RESET_PROGRESS_FILE_DATA:
      let fileInfo = action.payload.fileInfo;
      let filterProgressDropZoneFile = state.progressDropZoneFiles.filter(
        (p) => p.guid === fileInfo.guid
      );
      let filterIndexDropZone = state.progressDropZoneFiles.indexOf(
        filterProgressDropZoneFile[0]
      );
      let filterProgressFile = state.dropZoneDoc.filter(
        (p) => p.guid === fileInfo.guid
      );
      let filterIndex = state.dropZoneDoc.indexOf(filterProgressFile[0]);
      let resetData = state.dropZoneDoc;
      let resetProgressSideData = state.progressDropZoneFiles;
      let getlocalstoreData = JSON.parse(localStore.getItem(fileInfo.category));
      let getlocalstoreIndex = getlocalstoreData.findIndex(
        (file) => file.guid === fileInfo.guid
      );
      switch (action.payload.status) {
        case "Upload In-Progress":
          resetData[filterIndex] = {
            ...resetData[filterIndex],
            uploadingProgress:
              resetData[filterIndex].uploadingProgress +
                UtilsHelper.randomNumber([4, 5, 6]) >=
                99
                ? 99
                : resetData[filterIndex].uploadingProgress +
                UtilsHelper.randomNumber([4, 5, 6]),
          };
          resetProgressSideData[filterIndexDropZone] = {
            ...resetProgressSideData[filterIndexDropZone],
            uploadingProgress:
              resetData[filterIndex].uploadingProgress +
                UtilsHelper.randomNumber([4, 5, 6]) >=
                99
                ? 99
                : resetData[filterIndex].uploadingProgress +
                UtilsHelper.randomNumber([4, 5, 6]),
          };
          getlocalstoreData[getlocalstoreIndex] = {
            ...getlocalstoreData[getlocalstoreIndex],
            uploadingProgress:
              getlocalstoreData[getlocalstoreIndex].uploadingProgress +
                UtilsHelper.randomNumber([4, 5, 6]) >=
                99
                ? 99
                : getlocalstoreData[getlocalstoreIndex].uploadingProgress +
                UtilsHelper.randomNumber([4, 5, 6]),
            createdon: getlocalstoreData[getlocalstoreIndex].createdon,
            createdby: getlocalstoreData[getlocalstoreIndex].createdby,
          };
          localStore.setItem(
            fileInfo.category,
            JSON.stringify(getlocalstoreData)
          );
          return updateObject(state, {
            dropZoneDoc: resetData,
            progressDropZoneFiles: resetProgressSideData,
          });

        case "Scanning In-Progress":
          resetData[filterIndex] = {
            ...resetData[filterIndex],
            uploadingProgress:
              resetData[filterIndex].uploadingProgress +
                UtilsHelper.randomNumber([4, 5, 6]) >=
                99
                ? 99
                : resetData[filterIndex].uploadingProgress +
                UtilsHelper.randomNumber([4, 5, 6]),
          };
          resetProgressSideData[filterIndexDropZone] = {
            ...resetProgressSideData[filterIndexDropZone],
            uploadingProgress:
              resetProgressSideData[filterIndexDropZone].uploadingProgress +
                UtilsHelper.randomNumber([4, 5, 6]) >=
                99
                ? 99
                : resetProgressSideData[filterIndexDropZone].uploadingProgress +
                UtilsHelper.randomNumber([4, 5, 6]),
          };
          getlocalstoreData[getlocalstoreIndex] = {
            ...getlocalstoreData[getlocalstoreIndex],
            uploadingProgress:
              getlocalstoreData[getlocalstoreIndex].uploadingProgress +
                UtilsHelper.randomNumber([4, 5, 6]) >=
                99
                ? 99
                : resetData[filterIndex].uploadingProgress +
                UtilsHelper.randomNumber([4, 5, 6]),
            createdon: getlocalstoreData[getlocalstoreIndex].createdon,
            createdby: getlocalstoreData[getlocalstoreIndex].createdby,
          };
          localStore.setItem(
            fileInfo.category,
            JSON.stringify(getlocalstoreData)
          );
          return updateObject(state, {
            dropZoneDoc: resetData,
            progressDropZoneFiles: resetProgressSideData,
          });

        case "Import In-Progress":
          resetData[filterIndex] = {
            ...resetData[filterIndex],
            uploadingProgress: 99,
          };
          resetProgressSideData[filterIndexDropZone] = {
            ...resetProgressSideData[filterIndexDropZone],
            uploadingProgress: 99,
          };
          getlocalstoreData[getlocalstoreIndex] = {
            ...getlocalstoreData[getlocalstoreIndex],
            uploadingProgress: 99,
            createdon: getlocalstoreData[getlocalstoreIndex].createdon,
            createdby: getlocalstoreData[getlocalstoreIndex].createdby,
          };
          localStore.setItem(
            fileInfo.category,
            JSON.stringify(getlocalstoreData)
          );
          return updateObject(state, {
            dropZoneDoc: resetData,
            progressDropZoneFiles: resetProgressSideData,
          });

        case "Imported":
          resetData[filterIndex] = {
            ...resetData[filterIndex],
            isUploading: false,
          };
          getlocalstoreData[getlocalstoreIndex] = {
            ...getlocalstoreData[getlocalstoreIndex],
            isUploading: false,
            createdon: getlocalstoreData[getlocalstoreIndex].createdon,
            createdby: getlocalstoreData[getlocalstoreIndex].createdby,
          };
          localStore.setItem(
            fileInfo.category,
            JSON.stringify(getlocalstoreData)
          );
          return updateObject(state, {
            dropZoneDoc: resetData,
            previousDropZoneDoc: resetData,
          });

        case "cancelled":
          resetData = resetData.filter((data) => data.guid !== fileInfo.guid);
          resetProgressSideData = resetProgressSideData.filter(
            (data) => data.guid !== fileInfo.guid
          );
          resetData = resetData.filter((data) => data.guid !== fileInfo.guid);
          return updateObject(state, {
            dropZoneDoc: resetData,
            progressDropZoneFiles: resetProgressSideData,
          });

        default:
          return state;
      }
    default:
      return state;
  }
};
